import { englishValidationMessages } from './messages';
import { getMaxLengthValidator, getMinLengthValidator, getPatternValidator } from './rawValidators';
import { getRequiredValidator } from './required';
export function isPoBox(str) {
    // https://www.oreilly.com/library/view/regular-expressions-cookbook/9781449327453/ch04s17.html
    return /^(?:Post(?:al)? (?:Office )?|P[.\- ]?O\.? )?Box\b/im.test(str);
}
const maxLength = 50;
const minLength = 3;
const maxLengthValidator = getMaxLengthValidator(maxLength);
const minLengthValidator = getMinLengthValidator(minLength);
const streetNamePatternValidator = getPatternValidator(/^[a-zA-Z0-9 ,.()#'-]*$/);
export const getStreetNamePatternError = (valueName)=>englishValidationMessages.streetCharacters({
        field: valueName
    });
export function getStreetNameFailure(value) {
    if (!minLengthValidator(value)) {
        return 'tooShort';
    }
    if (!maxLengthValidator(value)) {
        return 'tooLong';
    }
    if (typeof value === 'string' && value && isPoBox(value)) {
        return 'poBox';
    }
    if (!streetNamePatternValidator(value)) {
        return 'invalidCharacters';
    }
    return null;
}
export const makeStreetNameValidators = (messages)=>{
    /** true means there's no error. false means there's an error. string means there's an error and gives the error-message. */ function getStreetNameFailureMessages() {
        let valueName = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : messages.fieldNames.streetName;
        return {
            tooShort: messages.tooShort({
                field: valueName,
                min: minLength
            }),
            tooLong: messages.tooLong({
                field: valueName,
                max: maxLength
            }),
            poBox: messages.poBox(),
            invalidCharacters: messages.streetCharacters({
                field: valueName
            })
        };
    }
    function getStreetNameValidator() {
        let valueName = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : messages.fieldNames.streetName, required = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
        const requiredValidator = getRequiredValidator(required);
        const failureErrors = getStreetNameFailureMessages(valueName);
        return (value)=>{
            const requiredError = requiredValidator(value);
            if (requiredError !== true) {
                return requiredError;
            }
            const failure = getStreetNameFailure(value);
            return failure == null ? true : failureErrors[failure];
        };
    }
    /** For react-hook-form library. */ const streetNameValidation = function streetNameValidation(valueName) {
        let { required } = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
        return {
            validate: {
                streetName: getStreetNameValidator(valueName, required)
            },
            dataAttr: {
                'data-validation': 'street-name'
            }
        };
    };
    return {
        getStreetNameFailureMessages,
        getStreetNameValidator,
        streetNameValidation
    };
};
export const { getStreetNameFailureMessages, getStreetNameValidator, streetNameValidation } = makeStreetNameValidators(englishValidationMessages);
